import { render, staticRenderFns } from "./CoachMedicalAssessmentFieldNote.vue?vue&type=template&id=10278468&scoped=true&"
import script from "./CoachMedicalAssessmentFieldNote.vue?vue&type=script&lang=js&"
export * from "./CoachMedicalAssessmentFieldNote.vue?vue&type=script&lang=js&"
import style0 from "./CoachMedicalAssessmentFieldNote.vue?vue&type=style&index=0&id=10278468&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10278468",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VBtn,VCol,VRow,VSpacer,VTextarea})
